// TODO
// The modal behaviour config could be modelled better.
// It's possible for this to define multiple opposing states
// (eg both jobModal and jbeModal set to appear on load).
// Also rename "collection" (data collection) to "jbe" (jobs by email)
// which is more explicit
//
// Maybe something that separates the `when` with the `what`...
// newConfig = {
//   modal?: {
//     onPageLoad: "jbe" | "job",
//     onJobClick: "jbe",
//     jbeModalType: "email" | "email,sms";
//     jobModalType: "close,submit";
//   },
// }

export enum ModalState {
  job = "job",
  email = "email",
  "email,sms" = "email,sms",
  "email,redirectToJob" = "email,redirectToJob",
}

export interface SERPConfig {
  numberOfJobsToCall: number;
  pushnami: boolean;
  onPageLoad?: "jbeModal" | "jobModal";
  onSERPJobClick?: "jbeModal";
  jbeModal?: ModalState;
  showJobModalOnJbeCloseAndSubmit?: true;
  googleSignIn?: boolean;
  googleOneTap?: boolean;
  serpPathWithJobModal: `/serp/3/` | `/serp/11/`; // ie, without any modal
  serpPathWithoutModal: `/serp/1/` | `/serp/8/`; // ie, without any modal
  hideGoogleAds?: true;
  hasExitIntent?: true;
  hasIndeedWidget?: true;
  withRgDirect?: true;

  // HACK to make DTL ads appear in hardcoded position
  // TODO - move to API
  positionOverride: Queries.SERPPageQuery["serp"]["config"]["positionOverride"];
}
